import { AccountProductEnum } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { Pressable, StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

interface ManageAccountNicknameProps {
  nickname?: string;
  label: string;
  isEditable?: boolean;
  accountId: string | undefined;
  accountType: AccountProductEnum;
}

const ManageAccountNickname = ({
  label,
  nickname,
  isEditable,
  accountId,
  accountType,
}: ManageAccountNicknameProps) => {
  const router = useRouter();
  const handleEditPress = () => {
    router.push({
      pathname: '/accounts/edit-account-name',
      params: {
        accountId,
        accountType,
      },
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.fullWidth}>
        <View style={styles.inputWrapper}>
          <BodyXSText style={styles.headingLabels}>{label}</BodyXSText>
          <BodyBaseText numberOfLines={1}>{nickname}</BodyBaseText>
        </View>
      </View>
      {isEditable ? (
        <Pressable
          onPress={handleEditPress}
          role="button"
          accessibilityLabel="nickname-edit-icon"
          hitSlop={10}
        >
          <Icon iconKey="EDIT" />
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    flexDirection: 'row',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
    padding: theme.spacing.m,
  },
  fullWidth: { flex: 1 },
  inputWrapper: {
    gap: theme.spacing.xs,
  },
  headingLabels: {
    color: theme.color.text.secondary,
  },
});

export default ManageAccountNickname;
